<div class="section">
  <div class="section-title">{{ LL.exerciseStats.logDetail.sets() }}</div>
  <div class="sets-list">
    @for (set of sets; track set) {
      <cs-note [attr.big]="isInPopover ? '' : null">{{ set.setText }}: {{ set.dataText }}</cs-note>
    }
  </div>
</div>
@if (hasNotes) {
  <div class="section">
    <div class="section-title">{{ LL.exerciseStats.logDetail.notes() }}</div>
    <div class="notes-list">
      @for (set of setsWithNotes; track set) {
        <cs-note [attr.big]="isInPopover ? '' : null">{{ set.setText }}: {{ set.userNotes }}</cs-note>
      }
    </div>
  </div>
}